import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import servicesData from '../Shared/servicesData';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';

function Services() {
  const navigate = useNavigate();

  return (
    <div className="pt-20 font-tt-lakes">
      <div className="bg-marine-black text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Our Services
            </h1>
            <p className="text-lg text-gray-300 max-w-3xl mx-auto">
              Comprehensive marine equipment solutions and services for your vessel
            </p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesData.map((service) => (
            <div 
              key={service.id} 
              onClick={() => navigate(`/services/${service.id}`)}
              className="cursor-pointer h-full"
            >
              <div className="bg-white rounded-xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 h-full">
                <div className="flex flex-col items-center text-center">
                  <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mb-6">
                    <service.icon className="w-8 h-8 text-marine-red" />
                  </div>
                  <h3 className="text-xl font-bold text-marine-black mb-4">
                    {service.title}
                  </h3>
                  <p className="text-gray-600">
                    {service.shortDescription}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl font-bold text-marine-black mb-6">
              Need Professional Support?
            </h2>
            <p className="text-gray-600 mb-8">
              Our team of experts is ready to help you with any marine equipment needs
            </p>
            <button className="bg-marine-red hover:bg-red-700 text-white px-8 py-3 rounded-lg transition-colors duration-300" onClick={() => navigate('/contact')}>
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;